import { useState, useEffect } from "react";
import axios from "axios";
import "./App.css";

import { Toaster } from "@/components/ui/sonner";
import { Login } from "@/components/Login";

import AppShell from "./app/AppShell";
import TraderPage from "./pages/TraderPage";
import ReportsPage from "./pages/ReportsPage";
import IdePage from "./pages/IdePage";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [activePage, setActivePage] = useState("trader");

  useEffect(() => {
    axios
      .get("/api/auth/me", { withCredentials: true })
      .then(() => setIsAuthenticated(true))
      .catch(() => setIsAuthenticated(false));
  }, []);

  if (isAuthenticated === null) {
    return (
      <div
        style={{
          background: "#000",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#00ff88",
          fontFamily: "monospace",
        }}
      >
        Loading...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black">
      {isAuthenticated ? (
        <AppShell activePage={activePage} onNavigate={setActivePage}>
          {activePage === "trader" ? (
              <TraderPage />
            ) : activePage === "ide" ? (
              <IdePage />
            ) : (
              <ReportsPage />
            )}
        </AppShell>
      ) : (
        <Login onLogin={() => setIsAuthenticated(true)} />
      )}

      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

export default App;
